module.exports = __webpack_public_path__ + "img/mechanical-design.5f8d7552.png";